import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Intro from '../components/home/intro';
import First from '../components/home/first';
import Interactivo from '../components/home/interactivo';
import Category from '../components/home/category';
import Presentation from '../components/home/presentation';
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Scrollspy from 'react-scrollspy'

export default class Index extends React.Component{
  state = {
    bg: '#5005f2',
    active: 'intro',
    results: false,
    showPresentation: true
  }

  componentDidMount(){

  }

  setCurrentSection(element){
    if(element){
      var id = element.getAttribute('id');
    }else{
      var id= false;
    }
    if(id){
      var color = '#4818c4';

      var dark = ['intro', 'interactivo'];

      switch(id){
        case "first":
          color = '#fbc402'
        break;
        case "interactivo":
          color = '#111';
        break;
        case "iresumen":
          color = '#111';
        break;
      }

      this.setState({
        // bg: color,
        active: id
      })

      // document.body.classList.remove('is-dark');
      // if(dark.indexOf(id) > -1){
      //   document.body.classList.add('is-dark');
      // }
    }
  }

  render(){
    return(
      <div id="home" style={{backgroundColor: this.state.bg}}>
          <div id="icontent">
            <div id="icontent_container">
            <Element name="first">
              <First mainTitle="Videos" active={this.state.active} hideIntro hidePosts/>
            </Element>
            </div>
          </div>
      </div>
    )
  }
}
